/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  GetAllTransmittalStatusesParams,
  IReadOnlyListOfTransmittalStatusDto,
  TransmittalStatusDto
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns all transmittalstatus enumeration values, with an optional filter.
 */
export const getAllTransmittalStatuses = (
    params?: GetAllTransmittalStatusesParams,
 options?: SecondParameter<typeof customInstance<IReadOnlyListOfTransmittalStatusDto>>,) => {
      return customInstance<IReadOnlyListOfTransmittalStatusDto>(
      {url: `/transmittal/transmittal-statuses`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Returns the TransmittalStatus identified by the route id.
 */
export const getTransmittalStatusById = (
    id: number,
 options?: SecondParameter<typeof customInstance<TransmittalStatusDto>>,) => {
      return customInstance<TransmittalStatusDto>(
      {url: `/transmittal/transmittal-statuses/${id}`, method: 'GET'
    },
      options);
    }
  export type GetAllTransmittalStatusesResult = NonNullable<Awaited<ReturnType<typeof getAllTransmittalStatuses>>>
export type GetTransmittalStatusByIdResult = NonNullable<Awaited<ReturnType<typeof getTransmittalStatusById>>>
